import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-heading font-semibold text-xl text-white mb-3">{title}</h2>
    <div className="text-grey-300 font-body leading-relaxed space-y-3">{children}</div>
  </section>
);

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-void">
      <header className="border-b border-white/5 bg-void-paper/50 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="text-grey-400 hover:text-white" aria-label="Go back">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <FileText className="w-5 h-5 text-neon-cyan" />
          <span className="font-heading font-bold text-white">Terms of Service</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <p className="text-grey-500 text-sm mb-8">Last updated: 31 May 2026</p>

        <Section title="1. Acceptance">
          <p>By creating an account or using RevealIQ Meet you agree to these Terms and to our Privacy Policy.
          If you do not agree, please do not use the service.</p>
        </Section>

        <Section title="2. The Service">
          <p>RevealIQ Meet provides video meetings with AI-assisted transcription, notes and a copilot, for
          office and educational use. Features may change or be discontinued over time.</p>
        </Section>

        <Section title="3. Acceptable Use">
          <ul className="list-disc ml-5 space-y-1">
            <li>Do not use the service for unlawful, harmful, or abusive purposes.</li>
            <li>Obtain consent from participants before recording or transcribing where required by law.</li>
            <li>Do not attempt to disrupt, reverse-engineer, or gain unauthorised access to the service.</li>
          </ul>
        </Section>

        <Section title="4. Your Content">
          <p>You retain ownership of your meeting content. You grant us a limited licence to process it
          solely to provide the service (e.g. generating transcripts and summaries).</p>
        </Section>

        <Section title="5. AI Output">
          <p>AI-generated summaries and answers may contain errors. They are provided "as is" and should
          not be solely relied upon for important decisions.</p>
        </Section>

        <Section title="6. Termination">
          <p>You may delete your account at any time from Settings. We may suspend accounts that violate
          these Terms.</p>
        </Section>

        <Section title="7. Disclaimer &amp; Liability">
          <p>The service is provided without warranties to the extent permitted by law. We are not liable
          for indirect or consequential damages arising from use of the service.</p>
        </Section>

        <Section title="8. Contact">
          <p>Questions about these Terms? Email
          <a className="text-neon-cyan hover:underline ml-1" href="mailto:support@revealiq.in">support@revealiq.in</a>.</p>
        </Section>
      </main>
    </div>
  );
};

export default TermsOfService;
